import { GitBranch, LoaderCircle, RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { api } from "@/api";

function fmt(value) {
  if (!value) return "—";
  return new Date(value).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
}

export const PipelinePanel = ({ onSelectRule, selectedRule, compact = false }) => {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const selectRule = (ruleId) => (onSelectRule ? onSelectRule(ruleId) : navigate(ruleId ? `/envois?rule=${ruleId}` : "/envois"));

  const load = (refresh = false) => api.get("/send-queue/pipeline", { params: refresh ? { refresh: 1 } : {} }).then(({ data: payload }) => setData(payload));

  useEffect(() => {
    load().catch(() => toast.error("Lecture du pipeline noCRM impossible."));
    const timer = setInterval(() => load().catch(() => {}), 15000);
    return () => clearInterval(timer);
  }, []);

  if (!data) return null;
  const steps = (data.steps || []).filter((step) => step.count > 0 || step.rule_id);

  return (
    <section className={`data-panel pipeline-panel${compact ? " is-compact" : ""}`} data-testid="pipeline-panel">
      <div className="panel-heading">
        <div>
          <p className="eyebrow">NOCRM EN DIRECT{data.pipeline ? ` — ${data.pipeline.toUpperCase()}` : ""}</p>
          <h2>Fiches par étape</h2>
        </div>
        <div className="journal-controls">
          <span className="table-count" data-testid="pipeline-fetched-at">
            {data.refreshing ? <><LoaderCircle size={12} className="spinning" /> Lecture noCRM en cours…</> : `Lu le ${fmt(data.fetched_at)}`}
          </span>
          <button type="button" className="icon-action" onClick={() => load(true)} disabled={data.refreshing} aria-label="Actualiser le pipeline" data-testid="pipeline-refresh-button"><RefreshCw size={16} /></button>
        </div>
      </div>
      {steps.length === 0 && <p className="empty-cell" data-testid="pipeline-empty">{data.refreshing ? "Première lecture du pipeline en cours, patientez quelques instants…" : "Aucune fiche trouvée."}</p>}
      {steps.length > 0 && (
        <div className="pipeline-grid">
          {steps.map((step) => {
            const active = selectedRule && selectedRule === step.rule_id;
            return (
              <button
                type="button"
                key={step.step_id}
                className={`pipeline-step${step.rule_id ? " has-rule" : ""}${active ? " active" : ""}`}
                onClick={() => step.rule_id && selectRule(active ? "" : step.rule_id)}
                disabled={!step.rule_id}
                title={step.rule_id ? (onSelectRule ? "Filtrer la file sur cette étape" : "Voir la file d’envoi de cette étape") : "Aucune automatisation sur cette étape"}
                data-testid={`pipeline-step-${step.step_id}`}
              >
                <span className="pipeline-step-name"><GitBranch size={13} /> {step.name}</span>
                <strong className="pipeline-step-count" data-testid={`pipeline-count-${step.step_id}`}>{step.count}</strong>
                <span className="pipeline-step-meta">Dernier déplacement : {fmt(step.last_moved_at)}</span>
                {step.rule_id && (
                  <span className="pipeline-step-meta pipeline-step-rule">
                    {step.rule_name} · {step.pending} en attente · {step.sent} envoyé{step.sent > 1 ? "s" : ""}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </section>
  );
};
